import { Entry } from '../Entry'

export function Entry20250326() {
  return (
    <Entry title="2025 Mar 26 - v3.10.6">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/17606/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
